import { combineReducers } from '@reduxjs/toolkit';

import languageProviderReducer from 'containers/LanguageProvider/reducer';
import ekycPageReducer from 'containers/EkycPage/reducer';
import appReducer from 'containers/App/reducer';

export default function createReducer(injectedReducers = {}) {
  const rootReducer = combineReducers({
    language: languageProviderReducer,
    ekyc: ekycPageReducer,
    app: appReducer,
    ...injectedReducers,
  });

  return rootReducer;
}
